import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaMobileAlt, FaShareSquare, FaPlusSquare } from 'react-icons/fa';
import { canInstall, isIOS, isMacSafari, isFirefoxDesktop, isStandalone, promptInstall, subscribe } from '../utils/pwaInstall';

// PWA 설치 안내 모달 — 플랫폼별 분기
// - Chrome/안드로이드(설치 프롬프트 보유): "지금 설치" 원클릭
// - iOS 사파리: "공유 → 홈 화면에 추가" 수동 안내(프롬프트 미지원)
// - 그 외/데스크톱(프롬프트 없음): 주소창 설치 아이콘/메뉴 안내
const InstallAppModal = ({ show, onClose }) => {
    const [installable, setInstallable] = useState(canInstall());
    const [installed, setInstalled] = useState(isStandalone());

    useEffect(() => {
        // 설치 프롬프트 도착/설치 완료 시 버튼 상태 갱신
        const unsub = subscribe(() => {
            setInstallable(canInstall());
            setInstalled(isStandalone());
        });
        return unsub;
    }, []);

    const ios = isIOS();
    const macSafari = !ios && isMacSafari();
    const firefox = !ios && !macSafari && isFirefoxDesktop();

    const handleInstall = async () => {
        const outcome = await promptInstall();
        if (outcome === 'accepted') {
            onClose();
        }
        setInstallable(canInstall());
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FaMobileAlt className="me-2" />
                    앱으로 설치하기
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {installed ? (
                    <p className="mb-0">이미 설치됨</p>
                ) : (
                    <>
                        <p className="text-muted">
                            washNote를 홈 화면(모바일)이나 바탕화면(PC)에 앱처럼 설치하면
                            주소 입력 없이 아이콘 한 번으로 바로 열 수 있어요.
                        </p>

                        {installable && (
                            <div className="text-center my-3">
                                <Button variant="primary" size="lg" onClick={handleInstall}>
                                    지금 설치하기
                                </Button>
                            </div>
                        )}

                        {!installable && ios && (
                            <ol className="mb-0 ps-3">
                                <li className="mb-2">
                                    사파리 하단의 <FaShareSquare className="mx-1" />
                                    <strong>공유</strong> 버튼을 누릅니다.
                                </li>
                                <li className="mb-2">
                                    <FaPlusSquare className="mx-1" />
                                    <strong>‘홈 화면에 추가’</strong>를 선택합니다.
                                </li>
                                <li>오른쪽 위 <strong>‘추가’</strong>를 누르면 완료됩니다.</li>
                            </ol>
                        )}

                        {!installable && macSafari && (
                            <ol className="mb-0 ps-3">
                                <li className="mb-2">
                                    사파리 상단 <strong>파일</strong> 메뉴를 엽니다.
                                </li>
                                <li>
                                    <FaPlusSquare className="mx-1" />
                                    <strong>‘Dock에 추가’</strong>를 선택합니다.
                                    <span className="text-muted"> (macOS Sonoma 이상)</span>
                                </li>
                            </ol>
                        )}

                        {!installable && firefox && (
                            <p className="mb-0">
                                이 브라우저(Firefox)는 앱 설치를 지원하지 않습니다.{' '}
                                <strong>Chrome·Edge</strong>(PC·안드로이드) 또는
                                <strong> Safari</strong>(iPhone·iPad·Mac)로 열면 설치할 수 있어요.
                            </p>
                        )}

                        {!installable && !ios && !macSafari && !firefox && (
                            <>
                                <p className="mb-2">
                                    <strong>이미 설치하셨다면</strong> 홈 화면·바탕화면의 washNote 아이콘으로 여시면 돼요.
                                </p>
                                <p className="mb-0 text-muted">
                                    아직이라면 — PC(Chrome·Edge): 주소창 오른쪽 설치 아이콘
                                    (<FaPlusSquare className="mx-1" />) 또는 메뉴 → ‘washNote 설치’ /
                                    안드로이드(Chrome): 메뉴(⋮) → ‘앱 설치’.
                                </p>
                            </>
                        )}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>닫기</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InstallAppModal;
